// docs/score/announcer-ui-redesign.md §3 — the four-band layout frame's
// fixed widths, plus the one breakpoint that changes how band 4 sits.
// NavRail's own width (72px / 200px) is owned by common-fe's
// NavRailContext, not here — AnnouncerFrame.jsx only owns the three bands
// it renders itself: the day, the live desk, and the look-up column.
export const DAY_BAND_WIDTH = 210;
export const LIVE_DESK_WIDTH = 560;
export const LOOKUP_BAND_WIDTH = 398;

// §3.6 — "Below ~1100px the look-up column stops sitting beside the desk
// and slides over it." NavRail, the day, and the desk never collapse at
// any width down to the supported floor (~1024px landscape) — that floor
// message is out of scope for this card, only the >=1100 vs <1100 split
// belongs to the frame itself.
export const LOOKUP_OVERLAY_BREAKPOINT_PX = 1100;
